// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3JoOP","log":"ModalInventoryLogs_log__2MuTS","date":"ModalInventoryLogs_date__1vDY-","userName":"ModalInventoryLogs_userName__2fntq"};